import { Directive, inject, input, InputSignal } from '@angular/core';
import { ProductBaseModel } from '@libs/shop/models';
import { ProductClickTrackingService, ProductTrackingListDirective } from '@libs/shared/tracking';
import { LinkDirective } from './link.directive';

@Directive({
  selector: 'a[uiProductLink]',
})
export class ProductLinkDirective extends LinkDirective<ProductBaseModel> {
  public enableProductClickTracking: InputSignal<boolean> = input(true);
  public position: InputSignal<number> = input(0);

  private readonly productClickTrackingService: ProductClickTrackingService = inject(ProductClickTrackingService);
  private readonly productTrackingList: ProductTrackingListDirective | null = inject(ProductTrackingListDirective, { optional: true });

  public override onClick(event: MouseEvent): void {
    super.onClick(event);

    if (this.enableProductClickTracking()) {
      this.productClickTrackingService.trackProductClick(this.link(), this.position(), this.productTrackingList?.trackingList());
    }
  }

  protected override getRawHref(link: ProductBaseModel): string {
    return this.linkRouter.getProductRawHref(link);
  }
}
